 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTDAN_COVER from '@/components/Text/Dan_cover'
 import TEXTDAN_DEDICATION from '@/components/Text/Dan_dedication'
 import TEXTDAN_TITLEPAGE from '@/components/Text/Dan_TitlePage'
 import TEXTDAN_CONTENTS from '@/components/Text/Dan_contents'
 import TEXTDAN_GENPREF from '@/components/Text/Dan_GenPref'
 import TEXTDAN_AUTPREF from '@/components/Text/Dan_AutPref'
 import TEXTDAN_ABBREV from '@/components/Text/Dan_Abbrev'
 import TEXTDAN_BIBLIO from '@/components/Text/Dan_Biblio'
 import TEXTDAN_INTRO from '@/components/Text/Dan_Intro'
 import TEXTDAN_ANALYSIS from '@/components/Text/Dan_Analysis'
 import TEXTDAN_CH01 from '@/components/Text/Dan_ch01'
 import TEXTDAN_CH02 from '@/components/Text/Dan_ch02'
 import TEXTDAN_CH03 from '@/components/Text/Dan_ch03'
 import TEXTDAN_CH04 from '@/components/Text/Dan_ch04'
 import TEXTDAN_CH05 from '@/components/Text/Dan_ch05'
 import TEXTDAN_CH06 from '@/components/Text/Dan_ch06'
 import TEXTDAN_CH07 from '@/components/Text/Dan_ch07'
 import TEXTDAN_CH08 from '@/components/Text/Dan_ch08'
 import TEXTDAN_CH09 from '@/components/Text/Dan_ch09'
 import TEXTDAN_CH10 from '@/components/Text/Dan_ch10'
 import TEXTDAN_NOTES from '@/components/Text/Dan_Notes'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTATA from '@/components/Text/ata'
 import TEXTSERIES from '@/components/Text/series'
 import TEXTMOREIVP from '@/components/Text/moreivp'
 import TEXTSELECTOR from '@/components/Text/selector'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Dan_contents",
 			"name" : "Text/Dan_contents",
 			"component" : TEXTDAN_CONTENTS
 		},
 		{
 			"path" : "/Text/Dan_GenPref",
 			"name" : "Text/Dan_GenPref",
 			"component" : TEXTDAN_GENPREF
 		},
 		{
 			"path" : "/Text/Dan_AutPref",
 			"name" : "Text/Dan_AutPref",
 			"component" : TEXTDAN_AUTPREF
 		},
 		{
 			"path" : "/Text/Dan_Abbrev",
 			"name" : "Text/Dan_Abbrev",
 			"component" : TEXTDAN_ABBREV
 		},
 		{
 			"path" : "/Text/Dan_Biblio",
 			"name" : "Text/Dan_Biblio",
 			"component" : TEXTDAN_BIBLIO
 		},
 		{
 			"path" : "/Text/Dan_Intro",
 			"name" : "Text/Dan_Intro",
 			"component" : TEXTDAN_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js